export default {
  '106': {max: 200},
  '113': {max: 100},
  '133': {max: 50 },
  '143': {max: 50 },
  '221': {max: 100},
  '222': {max: 100},
  '223': {max: 100},
  '224': {max: 100},
  '901': {max: 100},
  '902': {max: 100},
  '903': {max: 100},
  '301': {max: 100},
  '311': {max: 100},
  '911': {max: 200},
  '912': {max: 200},
  '913': {max: 200},
  '914': {max: 200},
  '411': {max: 100},
  '412': {max: 100},
  '421': {max: 100},
  '422': {max: 100},
  '431': {max: 100},
  '432': {max: 100},
  '451': {max: 100},
  '452': {max: 100},
  '453': {max: 100},
  '454': {max: 100},
  '512': {max: 50 },
  '522': {max: 50 },
  '532': {max: 50 },
  '542': {max: 50 },
  '513': {max: 100},
  '523': {max: 100},
  '533': {max: 100},
  '543': {max: 100},
}



// WEBPACK FOOTER //
// ./src/shared/constants/subject-scores.js